(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.ManageFillableForms",
                {
                    url: "/FillableForms",
                    component: "manageFillableForms",
                    requiredPermissions: [{ AccessObject: "FillableFormsAll", ActionType: "View" }],
                    resolve: {
                        fillableForms: ["fillableFormApi", function (fillableFormApi) {
                            return fillableFormApi.getFillableForms();
                        }],
                        entities: ["transactionGroupApi", function (transactionGroupApi) {
                            return transactionGroupApi.getTransactionGroups();
                        }]
                    }
                });
        }
    ]);

    app.component("manageFillableForms",
        {
            templateUrl: "/App/ManageFillableForms/template.html",
            controller: manageFillableFormsController,
            bindings: {
                fillableForms: "<",
                entities: "<"
            }
        });

    manageFillableFormsController.$inject = ["$mdDialog", "_", "$window", "fillableFormApi"];
    function manageFillableFormsController($mdDialog, _, $window, fillableFormApi) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                UI: {
                    SearchText: "",
                    Reverse: false
                },
                complete: complete,
                sort: sort,
                download: download
            });

        function complete(form, $event) {
            var confirm = $mdDialog.confirm({
                title: "Are you sure you want to complete this form?",
                targetEvent: $event,
                ariaLabel: "Confirm complete fillable form",
                ok: "Yes",
                cancel: "No",
                skipHide: true,
                clickOutsideToClose: false
            });
            $mdDialog.show(confirm).then(function () {
                form.Completing = true;
                fillableFormApi.complete(form.Id, form).then(function (response) {
                    form.CompletedById = response.CompletedById;
                    form.CompletedBy = response.CompletedBy;
                    form.CompletedOn = response.CompletedOn;
                    form.Completing = false;
                });
            });
        }

        function sort(sortText) {
            $ctrl.UI.Sort === sortText ? $ctrl.UI.Reverse = !$ctrl.UI.Reverse : $ctrl.UI.Reverse = false;
            $ctrl.UI.Sort = sortText;

            switch (sortText) {
                case "TransactionGroup.Name":
                    $ctrl.fillableForms = _.sortBy($ctrl.fillableForms, ["TransactionGroup.Name", "SubmittedOn"]);
                    break;
                case "SubmittedOn":
                    $ctrl.fillableForms = _.sortBy($ctrl.fillableForms, ["SubmittedOn", "TransactionGroup.Name"]);
                    break;
                case "CompletedOn":
                    $ctrl.fillableForms = _.sortBy($ctrl.fillableForms, ["CompletedOn", "TransactionGroup.Name"]);
                    break;
                case "CompletedBy":
                    var completedForms = _.remove($ctrl.fillableForms,
                        function(form) {
                            return !!form.CompletedBy;
                        });

                    completedForms = _.sortBy(completedForms, ["CompletedBy.FirstName", "CompletedBy.LastName", "TransactionGroupId.Name"]);

                    $ctrl.fillableForms = $ctrl.fillableForms.concat(completedForms);
                    break;
                case "Id":
                    $ctrl.fillableForms = _.sortBy($ctrl.fillableForms, ["Id", "TransactionGroup.Name"]);
                    break;
                case "FileName":
                    $ctrl.fillableForms = _.sortBy($ctrl.fillableForms, ["Title", "TransactionGroup.Name"]);
                    break;
            }

            if ($ctrl.UI.Reverse)
                $ctrl.fillableForms = $ctrl.fillableForms.reverse();
        }

        function download(form) {
            fillableFormApi.get(form.Id).then(function(response) {
                var url = URL.createObjectURL(response);

                $window.open(url, response.FileName);
            });
        }

        this.$onInit = function () {
            $ctrl.sort("CompletedBy");
        };
    }

})(window.app, window.angular); //jshint ignore:line